import React from "react";
import { createRoot } from "react-dom/client";
import { motion } from "framer-motion";
import "./index.css";

function App() {
  return (
      <div className="app-container">
        <motion.section
            className="text-center py-16 content-wrapper"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
        >
          <motion.h1
              className="headline"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
          >
            Gumis Budapest – Defektjavítás Budapest gyorsan és megbízhatóan
          </motion.h1>

          <motion.p
              className="subheadline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
          >
            Sürgős segítség kell? A Gumis Budapest szolgáltatás keretében akár 1 órán belül a helyszínre érkezem! Gyors <strong>defektjavítás Budapest</strong> teljes területén, hétvégén is.
          </motion.p>

          <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1, duration: 1 }}
          ></motion.div>

          <motion.h2
              className="headline mt-12"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2, duration: 1 }}
          >
            Szakszerű gumiszerviz kiszállással Budapesten
          </motion.h2>

          <motion.p
              className="subheadline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.4, duration: 1 }}
          >
            Szezonális gumicsere vagy hirtelen defekt miatt állt meg az autó? Bízza rám a problémát!
            <strong> Gumis Budapest </strong> szolgáltatásommal elkerülheti a várakozást és a sorban állást.
          </motion.p>

          <motion.p
              className="subheadline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.6, duration: 1 }}
          >
            A <strong>defektjavítás Budapesten</strong> nálam egyszerű és gyors folyamat. Legyen szó szög által okozott hibáról, szelephibáról vagy felni problémáról – 15+ év tapasztalattal megoldom!
          </motion.p>

          <motion.p
              className="subheadline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.8, duration: 1 }}
          >
            A mobil <strong>gumicsere</strong> Budapest egész területén elérhető nálam, a következő előnyökkel:
          </motion.p>

          <ul className="subheadline" style={{ textAlign: "left", listStyleType: "✔️", marginTop: "1rem" }}>
            <li>Nem kell elhagynod otthonod – a <strong>gumicsere Budapesten</strong> házhoz jön!</li>
            <li>Nincs várakozás vagy sorban állás szervizben.</li>
            <li>Megbízható és gyors kiszállás, korrekt árak.</li>
            <li>Igény esetén a lecserélt gumikat is elviszem, és tárolom a következő szezonig.</li>
          </ul>

          <a href="tel:+36204688046">
            <button className="cta-button" style={{ marginTop: "2rem" }}>
              Hívj most!
            </button>
          </a>
        </motion.section>
      </div>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
